import React from "react";
import { FileText } from "lucide-react";

interface Props {
  commands: any[];
}

const TicketPreviewSection: React.FC<Props> = ({ commands }) => {
  return (
    <section className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark overflow-hidden transition">
      {/* === Header === */}
      <div className="border-b border-stroke dark:border-strokedark px-4 py-3 sm:px-5 xl:px-6 flex items-center gap-2">
        <FileText className="w-5 h-5 text-primary" />
        <h3 className="font-semibold text-black dark:text-white">
          Vista Previa del Ticket
        </h3>
      </div>

      {/* === Body === */}
      <div className="p-4 sm:p-5 xl:p-6">
        <div className="bg-gray-100 dark:bg-gray-900 p-3 rounded-md overflow-y-auto max-h-[300px] text-xs font-mono text-gray-800 dark:text-gray-100 border border-gray-200 dark:border-gray-700 scrollbar-thin scrollbar-thumb-gray-400 dark:scrollbar-thumb-gray-600 scrollbar-track-transparent">
          {commands.length > 0 ? (
            commands.map((cmd, idx) => (
              <div key={idx} className="mb-1">
                <span className="text-gray-500 dark:text-gray-400">[{idx}]</span>{" "}
                {JSON.stringify(cmd)}
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-500 dark:text-gray-400 italic">
              No hay comandos para mostrar.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default TicketPreviewSection;
